export function generatePaginationBody(page, pageSize, sorted, filtered) {
    return {
        itemsPerPage: pageSize !== undefined && pageSize !== null && pageSize !== 0 ? pageSize : 20,
        page: page ? page + 1 : 1,
        sorted,
    };
}
